import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import palette from '@telus-uds/palette-allium/build/web/palette';

const { colorAccessibleGreen, colorTelusPurple } = {
  colorAccessibleGreen: palette.color.greenAccessible,
  colorTelusPurple: palette.color.purpleTelus
};
import { Box } from './../../design/css';
import { Typography } from '@telus-uds/components-web';

const DefectComments = ({ data, isAdmin }) => {
  return (
    <>
      {data.map((comment, index) => {
        const {
          text,
          is_admin_only,
          updatedAt,
          commenter_name: userName,
          commenter_role_id: roleId
        } = comment;

        const commentDate = moment(updatedAt).format(
          'dddd, MMMM Do YYYY, h:mm:ss a'
        );
        const key = `comment${index}`;
        let isAddedByAdmin = roleId === 1;
        const adminLabel = <Typography>{is_admin_only ? "[Admins only]" :""}</Typography>;
        const getAdmin = () => {
          return <Typography>{userName}{"  "}<span style={{ color: "#2B8000" }}>{adminLabel}{"  "}</span>{" -  "}</Typography>
        }
        return (
          <>
            {
              !isAdmin && is_admin_only ? null
                : text && (
                  <Box key={key} top={4}>
                    <Typography variant={{ bold: true, colour: 'brand' }}>
                      {isAddedByAdmin ? (isAdmin ? getAdmin() : 'Support - ') : `${userName} - `}
                    </Typography>
                    <Typography>{`${text} - `}</Typography>
                    <Typography variant={{ bold: true, colour: 'positive' }}>
                      {commentDate}
                    </Typography>
                  </Box>
                )
            }
          </>
        );

      })}
    </>
  );
};

DefectComments.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      createdAt: PropTypes.string,
      user: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string
      })
    })
  ).isRequired
};

export default DefectComments;
